import { getInstance as getReactI13nInstance, type ReactI13nPlugin } from 'react-i13n';

export interface I13nPluginClass {
  getPlugin: () => ReactI13nPlugin;
}

let i13n, instance;

export class I13nWithQueue {
  queue: any[] = [];

  execute(...args: any[]) {
    if (!i13n) {
      i13n = getReactI13nInstance();
      // push to the queue if i13n instance is not ready
      this.queue.push(args);
    } else {
      i13n.execute(...args);
      this.flush();
    }
  }

  flush() {
    while (this.queue.length) {
      const args: any[] = this.queue.shift();
      i13n.execute(...args);
    }
  }
}

export default function getInstance(): I13nWithQueue {
  if (!instance) {
    instance = new I13nWithQueue();
  }
  return instance;
}
